// 店舗検索結果ページ — GAS から店舗取得 / 地図表示 / URL パラメータで絞り込み

const SHOP_DATA_URL = window.shopListConfig?.apiUrl;

const loading = document.getElementById('shoplistLoading');
const loadingText = document.getElementById('shoplistLoadingText');
const result = document.getElementById('shoplistResult');
const cityListRoot = document.getElementById('shopCityList');
const headingTitle = document.getElementById('shoplistDetailTitle');

const SHOP_DATA_CACHE_KEY = 'shopListStores';
const SHOP_DATA_CACHE_TIME_KEY = 'shopListStoresCachedAt';
const SHOP_DATA_CACHE_LIMIT = 1000 * 60 * 10;
const SHOP_DATA_RETRY_DELAY = 1000;

const MAP_PIN_ICON = `<span class="cm-page-shoplist-detail__store-map-icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="m9.91 18.59 5.036-8.78c2.228-3.886-.525-8.777-4.942-8.777-4.385 0-7.147 4.822-4.992 8.713zM10.004 0C4.845 0 1.593 5.673 4.13 10.255l5.212 9.41a.64.64 0 0 0 1.12.009l5.358-9.342C18.445 5.755 15.202 0 10.004 0"/><path d="M13 6.796c0 1.76-1.399 3.187-3.124 3.187S6.752 8.556 6.752 6.796s1.399-3.187 3.124-3.187S13 5.036 13 6.796M9.876 8.949c1.166 0 2.11-.964 2.11-2.153s-.944-2.153-2.11-2.153-2.11.964-2.11 2.153.944 2.153 2.11 2.153"/></svg></span>`;

let currentMap = null;
let currentMarkers = [];
let currentInfoOverlay = null;

const MAP_POPUP_CLOSE_ICON = `<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1.5 1.5L6.5 6.5M6.5 1.5L1.5 6.5" stroke="currentColor" stroke-width="0.9" stroke-linecap="round"/></svg>`;

function buildStoreMapPopupHtml(store) {
  const routeUrl = `https://www.google.com/maps/dir/?api=1&destination=${store.latitude},${store.longitude}`;

  return `
    <button type="button" class="cm-page-shoplist-detail__map-popup-close" aria-label="閉じる">
      ${MAP_POPUP_CLOSE_ICON}
    </button>
    <div class="cm-page-shoplist-detail__map-popup-body">
      <p class="cm-page-shoplist-detail__map-popup-name">${escapeHtml(store.shop_name)}</p>
      <p class="cm-page-shoplist-detail__map-popup-line">〒${escapeHtml(store.zip)}</p>
      <p class="cm-page-shoplist-detail__map-popup-line">${escapeHtml(store.prefecture)}${escapeHtml(store.city)}${escapeHtml(store.address)}</p>
      ${store.tel ? `<p class="cm-page-shoplist-detail__map-popup-line">${escapeHtml(store.tel)}</p>` : ''}
      <a class="cm-page-shoplist-detail__map-popup-directions" href="${routeUrl}" target="_blank" rel="noopener">
        行き方を調べる
      </a>
    </div>
    <span class="cm-page-shoplist-detail__map-popup-tail" aria-hidden="true"></span>
  `;
}

function createStoreMapInfoOverlay(store, position) {
  class StoreMapInfoOverlay extends google.maps.OverlayView {
    constructor(storeData, latLng) {
      super();
      this.storeData = storeData;
      this.latLng = latLng;
      this.container = null;
    }

    onAdd() {
      this.container = document.createElement('div');
      this.container.className = 'cm-page-shoplist-detail__map-popup';
      this.container.innerHTML = buildStoreMapPopupHtml(this.storeData);

      this.container.querySelector('.cm-page-shoplist-detail__map-popup-close')?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.close();
      });

      this.getPanes().floatPane.appendChild(this.container);
    }

    draw() {
      if (!this.container) return;

      const projection = this.getProjection();
      if (!projection) return;

      const point = projection.fromLatLngToDivPixel(this.latLng);
      const width = this.container.offsetWidth;
      const height = this.container.offsetHeight;
      const markerOffset = 42;

      this.container.style.left = `${point.x - width / 2}px`;
      this.container.style.top = `${point.y - height - markerOffset}px`;
    }

    onRemove() {
      this.container?.remove();
      this.container = null;
    }

    close() {
      this.setMap(null);

      if (currentInfoOverlay === this) {
        currentInfoOverlay = null;
      }
    }
  }

  return new StoreMapInfoOverlay(store, position);
}

const MAP_MARKER_OFFSET_PX = 42;
const MAP_POPUP_VISIBLE_MARGIN_PX = 16;
const MAP_POPUP_SP_TOP_MARGIN_PX = 64; // 地図/航空写真コントロール下の余白

let mapPopupAdjustToken = 0;
let mapPopupIdleListener = null;
let mapPopupFallbackTimer = null;

function clearMapPopupPadding() {
  if (!currentMap) return;

  currentMap.setOptions({
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
  });
}

function isShoplistMapSpViewport() {
  return window.matchMedia('(max-width: 999px)').matches;
}

function clearMapPopupAdjustSchedule() {
  mapPopupAdjustToken += 1;

  if (mapPopupIdleListener && currentMap) {
    google.maps.event.removeListener(mapPopupIdleListener);
    mapPopupIdleListener = null;
  }

  if (mapPopupFallbackTimer !== null) {
    window.clearTimeout(mapPopupFallbackTimer);
    mapPopupFallbackTimer = null;
  }
}

function whenMapIdle(callback) {
  if (!currentMap) return;

  if (mapPopupIdleListener) {
    google.maps.event.removeListener(mapPopupIdleListener);
    mapPopupIdleListener = null;
  }

  mapPopupIdleListener = google.maps.event.addListenerOnce(currentMap, 'idle', () => {
    mapPopupIdleListener = null;
    callback();
  });
}

/**
 * panTo 直後（マーカーがマップ中央にある前提）で吹き出しが見える位置へ1回だけずらす。
 * 現在の吹き出し画面座標は使わない（移動アニメ途中の誤計測を防ぐ）。
 */
function adjustStoreInfoOverlayAfterCentered(overlay) {
  if (!currentMap || !overlay?.container) return false;

  const mapDiv = currentMap.getDiv();
  const mapWidth = mapDiv.offsetWidth;
  const mapHeight = mapDiv.offsetHeight;
  const popupWidth = overlay.container.offsetWidth;
  const popupHeight = overlay.container.offsetHeight;

  if (!popupWidth || !popupHeight) return false;

  if (isShoplistMapSpViewport()) {
    const markerTargetY = MAP_POPUP_SP_TOP_MARGIN_PX + popupHeight + MAP_MARKER_OFFSET_PX;
    const centerY = mapHeight / 2;
    const panY = centerY - markerTargetY;

    if (Math.abs(panY) > 1) {
      currentMap.panBy(0, panY);
    }

    return true;
  }

  const topMargin = MAP_POPUP_VISIBLE_MARGIN_PX;
  const sideMargin = MAP_POPUP_VISIBLE_MARGIN_PX;
  const bottomMargin = MAP_POPUP_VISIBLE_MARGIN_PX;
  const centerX = mapWidth / 2;
  const centerY = mapHeight / 2;
  const popupLeft = centerX - popupWidth / 2;
  const popupTop = centerY - popupHeight - MAP_MARKER_OFFSET_PX;
  const popupRight = popupLeft + popupWidth;
  const popupBottom = centerY - MAP_MARKER_OFFSET_PX;

  let panX = 0;
  let panY = 0;

  if (popupTop < topMargin) {
    panY = popupTop - topMargin;
  } else if (popupBottom > mapHeight - bottomMargin) {
    panY = popupBottom - (mapHeight - bottomMargin);
  }

  if (popupLeft < sideMargin) {
    panX = popupLeft - sideMargin;
  } else if (popupRight > mapWidth - sideMargin) {
    panX = popupRight - (mapWidth - sideMargin);
  }

  if (panX !== 0 || panY !== 0) {
    currentMap.panBy(panX, panY);
  }

  return true;
}

function scheduleAdjustStoreInfoOverlay(overlay) {
  if (!currentMap || !overlay) return;

  const token = mapPopupAdjustToken;
  let ran = false;

  const run = () => {
    if (ran || token !== mapPopupAdjustToken || currentInfoOverlay !== overlay) return;

    const tryAdjust = () => {
      if (ran || token !== mapPopupAdjustToken || currentInfoOverlay !== overlay) return;

      if (!adjustStoreInfoOverlayAfterCentered(overlay)) {
        return false;
      }

      ran = true;

      if (mapPopupFallbackTimer !== null) {
        window.clearTimeout(mapPopupFallbackTimer);
        mapPopupFallbackTimer = null;
      }

      return true;
    };

    if (tryAdjust()) return;

    // 吹き出し DOM 未計測のときは次フレームで再試行
    window.requestAnimationFrame(() => {
      tryAdjust();
    });
  };

  whenMapIdle(run);

  mapPopupFallbackTimer = window.setTimeout(() => {
    mapPopupFallbackTimer = null;
    run();
  }, 450);
}

function openStoreInfoOnMap(store, marker, options = {}) {
  if (!currentMap || !marker) return;

  closeStoreInfo();

  currentInfoOverlay = createStoreMapInfoOverlay(store, marker.getPosition());
  currentInfoOverlay.setMap(currentMap);

  const token = mapPopupAdjustToken;
  const targetZoom = options.zoom;
  const position = marker.getPosition();

  const panThenAdjust = () => {
    if (token !== mapPopupAdjustToken || currentInfoOverlay !== overlayRef) return;

    currentMap.panTo(position);
    scheduleAdjustStoreInfoOverlay(overlayRef);
  };

  const overlayRef = currentInfoOverlay;

  if (typeof targetZoom === 'number' && currentMap.getZoom() !== targetZoom) {
    currentMap.setZoom(targetZoom);
    whenMapIdle(() => {
      if (token !== mapPopupAdjustToken) return;
      panThenAdjust();
    });
    return;
  }

  panThenAdjust();
}

function closeStoreInfo() {
  clearMapPopupAdjustSchedule();

  if (currentInfoOverlay) {
    currentInfoOverlay.close();
    currentInfoOverlay = null;
  }

  clearMapPopupPadding();
}

/**
 * 店舗データを取得
 */
function requestShopData() {
  if (!SHOP_DATA_URL) {
    return Promise.reject(new Error('店舗データのURLが設定されていません。'));
  }

  return fetch(SHOP_DATA_URL).then((response) => {
    if (!response.ok) {
      throw new Error(`店舗データ取得エラー: ${response.status}`);
    }

    return response.json();
  });
}

/**
 * 店舗データを取得
 * - sessionStorageに有効なキャッシュがあれば使用
 * - キャッシュがなければJSONから取得
 * - 取得失敗時は1秒後に1回だけリトライ
 */
function fetchShopData() {
  const cachedData = sessionStorage.getItem(SHOP_DATA_CACHE_KEY);
  const cachedAt = Number(sessionStorage.getItem(SHOP_DATA_CACHE_TIME_KEY));

  if (cachedData && cachedAt && Date.now() - cachedAt < SHOP_DATA_CACHE_LIMIT) {
    try {
      return Promise.resolve(JSON.parse(cachedData));
    } catch (error) {
      sessionStorage.removeItem(SHOP_DATA_CACHE_KEY);
      sessionStorage.removeItem(SHOP_DATA_CACHE_TIME_KEY);
    }
  }

  return requestShopData()
    .catch((error) => {
      console.warn('店舗データの取得に失敗しました。1秒後に再試行します。', error);

      return new Promise((resolve) => {
        window.setTimeout(resolve, SHOP_DATA_RETRY_DELAY);
      }).then(() => requestShopData());
    })
    .then((stores) => {
      try {
        sessionStorage.setItem(SHOP_DATA_CACHE_KEY, JSON.stringify(stores));
        sessionStorage.setItem(SHOP_DATA_CACHE_TIME_KEY, String(Date.now()));
      } catch (error) {
        console.warn('店舗データをsessionStorageに保存できませんでした。', error);
      }

      return stores;
    });
}

function updatePageHeading(prefecture, area, keyword, mode) {
  if (!headingTitle) return;

  if (prefecture) {
    headingTitle.textContent = `${prefecture}の店舗一覧`;
    return;
  }

  if (area) {
    headingTitle.textContent = `${area}の店舗一覧`;
    return;
  }

  if (keyword) {
    headingTitle.textContent = `「${keyword}」の検索結果`;
    return;
  }

  if (mode === 'gps') {
    headingTitle.textContent = '現在地から近い店舗';
  }
}

function escapeHtml(value) {
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function hasLocation(store) {
  return Number.isFinite(Number(store.latitude)) && Number.isFinite(Number(store.longitude));
}

fetchShopData()
  .then((stores) => {
    const params = new URLSearchParams(window.location.search);
    const area = params.get('area');
    const prefecture = params.get('prefecture');
    const keyword = params.get('keyword');
    const mode = params.get('mode');

    updatePageHeading(prefecture, area, keyword, mode);

    function getDistance(lat1, lng1, lat2, lng2) {
      const R = 6371;
      const toRad = (deg) => (deg * Math.PI) / 180;

      const dLat = toRad(lat2 - lat1);
      const dLng = toRad(lng2 - lng1);

      const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;

      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      return R * c;
    }

    function openStoreInfo(store, marker, options = {}) {
      openStoreInfoOnMap(store, marker, options);
    }

    function renderMap(storesToRender, userLocation = null) {
      const mapElement = document.getElementById('shopMap');
      if (!mapElement) return;
      const storesWithLocation = storesToRender.filter(hasLocation);

      closeStoreInfo();
      currentMarkers = [];

      if (!storesWithLocation.length) {
        mapElement.style.display = 'none';
        return;
      }

      mapElement.style.display = 'block';

      const firstStore = storesWithLocation[0];

      currentMap = new google.maps.Map(mapElement, {
        center: {
          lat: Number(firstStore.latitude),
          lng: Number(firstStore.longitude),
        },
        zoom: 12,
      });

      const bounds = new google.maps.LatLngBounds();

      storesWithLocation.forEach((store) => {
        const marker = new google.maps.Marker({
          position: {
            lat: Number(store.latitude),
            lng: Number(store.longitude),
          },
          map: currentMap,
          title: store.shop_name,
        });

        marker.storeHandle = store.handle;
        currentMarkers.push(marker);

        bounds.extend(marker.getPosition());

        marker.addListener('click', () => {
          openStoreInfo(store, marker);
        });
      });

      if (userLocation) {
        const userMarker = new google.maps.Marker({
          position: {
            lat: userLocation.lat,
            lng: userLocation.lng,
          },
          map: currentMap,
          title: '現在地',
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 8,
            fillColor: '#4285F4',
            fillOpacity: 1,
            strokeColor: '#ffffff',
            strokeWeight: 2,
          },
        });

        bounds.extend(userMarker.getPosition());
      }

      if (storesWithLocation.length === 1) {
        currentMap.setCenter({
          lat: Number(firstStore.latitude),
          lng: Number(firstStore.longitude),
        });
        currentMap.setZoom(15);
      } else {
        currentMap.fitBounds(bounds);
      }

      const firstMarker = currentMarkers[0];
      if (firstMarker) {
        openStoreInfo(firstStore, firstMarker);
      }
    }

    function renderCityList(storesToRender) {
      if (!cityListRoot) return;

      const cityCounts = {};

      storesToRender.forEach((store) => {
        cityCounts[store.city] = (cityCounts[store.city] || 0) + 1;
      });

      const cities = Object.entries(cityCounts).sort(([a], [b]) => a.localeCompare(b, 'ja'));

      if (!cities.length) {
        cityListRoot.hidden = true;
        cityListRoot.innerHTML = '';
        return;
      }

      cityListRoot.hidden = false;
      cityListRoot.innerHTML = `
        <p class="cm-page-shoplist-detail__cities-heading">市区町村</p>
        <div class="cm-page-shoplist-detail__cities-grid">
          ${cities
            .map(
              ([city, count]) => `
                <a href="#city-${escapeHtml(city)}" class="cm-page-shoplist-detail__city-link">
                  <span class="cm-page-shoplist-detail__city-name">${escapeHtml(city)}</span><span class="cm-page-shoplist-detail__city-count">(${count})</span>
                </a>
              `,
            )
            .join('')}
        </div>
      `;
    }

    function focusStoreOnMap(handle, storesToRender) {
      const store = storesToRender.find((item) => item.handle === handle);
      const marker = currentMarkers.find((item) => item.storeHandle === handle);

      if (!store || !marker || !currentMap) return;

      const mapTop = document.getElementById('shopMap').getBoundingClientRect().top + window.pageYOffset - 95;

      window.scrollTo({
        top: mapTop,
        behavior: 'smooth',
      });

      openStoreInfo(store, marker, { zoom: 15 });
    }

    function bindStoreItems(storesToRender) {
      document.querySelectorAll('.js-shop-store-item').forEach((item) => {
        const activate = () => {
          focusStoreOnMap(item.dataset.handle, storesToRender);
        };

        item.addEventListener('click', activate);
        item.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;

          event.preventDefault();
          activate();
        });
      });

      document.querySelectorAll('.cm-page-shoplist-detail__store-map-link').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.stopPropagation();
        });
        link.addEventListener('keydown', (event) => {
          event.stopPropagation();
        });
      });
    }

    function renderStores(storesToRender, userLocation = null) {
      loading.hidden = true;

      if (!storesToRender.length) {
        renderMap([]);
        result.innerHTML = `
          <p class="cm-page-shoplist-detail__empty">
            該当する店舗が見つかりませんでした。
          </p>
        `;
        return;
      }

      renderMap(storesToRender, userLocation);

      const groupedStores = storesToRender.reduce((groups, store) => {
        const city = store.city || 'その他';

        if (!groups[city]) {
          groups[city] = [];
        }

        groups[city].push(store);

        return groups;
      }, {});

      result.innerHTML = `
        ${Object.entries(groupedStores)
          .map(
            ([city, cityStores]) => `

              <section class="cm-page-shoplist-detail__city-section" id="city-${escapeHtml(city)}">
                <h2 class="cm-page-shoplist-detail__city-heading">
                  <span class="cm-page-shoplist-detail__city-heading-name">${escapeHtml(city)}</span>
                  <span class="cm-page-shoplist-detail__city-heading-count">（${cityStores.length}）</span>
                </h2>

                <ul class="cm-page-shoplist-detail__store-list">
                  ${cityStores
                    .map(
                      (store) => `
                        <li class="cm-page-shoplist-detail__store">
                          <div
                            class="cm-page-shoplist-detail__store-body js-shop-store-item"
                            data-handle="${escapeHtml(store.handle)}"
                            role="button"
                            tabindex="0"
                            aria-label="${escapeHtml(store.shop_name)}を地図で表示"
                          >
                            <span class="cm-page-shoplist-detail__store-name">
                              ${escapeHtml(store.shop_name)}
                            </span>
                            ${String(store.campaign).toLowerCase() === 'true' ? `<p class="cm-page-shoplist-detail__store-campaign">頭皮チェックイベント実施店舗</p>` : ''}
                            <address class="cm-page-shoplist-detail__store-address">
                              <p>〒${escapeHtml(store.zip)}</p>
                              <p>${escapeHtml(store.prefecture)}${escapeHtml(store.city)}${escapeHtml(store.address)}</p>
                              ${store.tel ? `<p>TEL：${escapeHtml(store.tel)}</p>` : ''}
                            </address>
                            ${store.distance ? `<div class="cm-page-shoplist-detail__store-meta"><p>現在地から約${store.distance.toFixed(1)}km</p></div>` : ''}
                            ${store.note ? `<p class="cm-page-shoplist-detail__store-note">${escapeHtml(store.note)}</p>` : ''}
                          </div>
                          ${store.latitude && store.longitude ? `<a href="https://www.google.com/maps/search/?api=1&query=${store.latitude},${store.longitude}" class="cm-page-shoplist-detail__store-map-link" target="_blank" rel="noopener">${MAP_PIN_ICON}GoogleMapで見る</a>` : ''}
                        </li>
                      `,
                    )
                    .join('')}
                </ul>
              </section>
            `,
          )
          .join('')}
      `;

      bindStoreItems(storesToRender);
    }

    let filteredStores = stores;

    if (area) {
      filteredStores = filteredStores.filter((store) => store.area === area);
    }

    if (prefecture) {
      filteredStores = filteredStores.filter((store) => store.prefecture === prefecture);
      renderCityList(filteredStores);
    }

    if (keyword) {
      const searchText = keyword.trim().toLowerCase();

      filteredStores = filteredStores.filter((store) => {
        return [store.shop_name, store.prefecture, store.city, store.address, store.tel, store.note].join('').toLowerCase().includes(searchText);
      });

      renderStores(filteredStores);
      return;
    }

    if (mode === 'gps') {
      if (!navigator.geolocation) {
        loading.hidden = true;
        result.innerHTML = '<p class="cm-page-shoplist-detail__error">このブラウザでは位置情報を取得できません。</p>';
        return;
      }

      if (loadingText) {
        loadingText.textContent = '現在地を取得しています...';
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLat = position.coords.latitude;
          const userLng = position.coords.longitude;

          const nearestStores = stores
            .filter(hasLocation)
            .map((store) => {
              const distance = getDistance(userLat, userLng, store.latitude, store.longitude);

              return {
                ...store,
                distance,
              };
            })
            .sort((a, b) => a.distance - b.distance)
            .slice(0, 5);

          renderStores(nearestStores, {
            lat: userLat,
            lng: userLng,
          });
        },
        (error) => {
          loading.hidden = true;
          result.innerHTML = '<p class="cm-page-shoplist-detail__error">位置情報を取得できませんでした。</p>';
          console.error(error);
        },
      );

      return;
    }

    renderStores(filteredStores);
  })
  .catch((error) => {
    loading.hidden = true;

    result.innerHTML = `
      <div class="cm-page-shoplist-detail__error">
        <p>
          店舗情報を取得できませんでした。<br>
          お手数ですが、時間をおいて再度お試しください。
        </p>
        <button
          type="button"
          class="cm-page-shoplist-detail__reload"
          id="shoplistReload"
        >
          再読み込み
        </button>
      </div>
    `;

    document.getElementById('shoplistReload')?.addEventListener('click', () => {
      location.reload();
    });

    console.error('店舗データを取得できませんでした。', error);
  });
